module.exports = __webpack_public_path__ + "img/partners_alibaba.653f7d9c.png";